import { Avatar, SxProps, Theme } from "@mui/material";
import { IAvatarSize } from "src/components-mui/base/avatar/avatar.constants";
import { buildAvatarImageUrl, getAvatarPixelSize } from "src/components-mui/base/avatar/avatar.utils";

interface IUnderlyingLogoProps {
    logoUrl: string;
    size: IAvatarSize;
    alt?: string;
    sx?: SxProps<Theme>;
}

export const UnderlyingLogo = ({ logoUrl, size, alt = "", sx }: IUnderlyingLogoProps) => {
    const pixelSize = getAvatarPixelSize(size);

    return (
        <Avatar
            src={buildAvatarImageUrl(logoUrl, size)}
            alt={alt}
            sx={[
                {
                    width: pixelSize,
                    height: pixelSize,
                    outline: "1px solid",
                    outlineColor: "gray.100",
                    outlineOffset: "-1px",
                    backgroundColor: "common.white",
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        />
    );
};
